import { type TUser as TApiUser, getUserUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

import { convertUser } from '@core/converters'

export const getUser = async (params?: { signal?: AbortSignal }) => {
    const apiUser = await httpClient
        .get(withQuery(getUserUrl(), { expand: 'stats' }), { signal: params?.signal })
        .json<TApiUser>()

    return convertUser(apiUser)
}
